import type { TypePolicies } from "@apollo/client"

export const typePoliciesHiringFields: TypePolicies = {
  Hiring: {
    merge: true,
    fields: {
      onboardingForm: {
        merge(existing, incoming, { mergeObjects }) {
          return mergeObjects(existing, incoming)
        },
      },
      employeeProcess: {
        merge(existing, incoming, { mergeObjects }) {
          return mergeObjects(existing, incoming)
        },
      },
      companyProcess: {
        merge(existing, incoming, { mergeObjects }) {
          return mergeObjects(existing, incoming)
        },
      },
      hiringProcess: {
        merge(existing, incoming, { mergeObjects }) {
          return mergeObjects(existing, incoming)
        },
      },
    },
  },
}
